import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, IconButton } from '@material-ui/core';
import classnames from 'classnames';

import { SkillIcon, ClearIcon, InfoIcon } from '../../../common/icons';

const styles = theme => ({
    root: {
        padding: theme.spacing(1),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: theme.colors.grey2,
        position: 'relative',
    },
    moduleIcon: {
        fontSize: theme.sizes.largeIcon,
        marginBottom: theme.spacing(1),
    },
    removeIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: theme.spacing(0.5),
    },
    infoIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: theme.spacing(0.5),
    },
});

class SelectedSkill extends React.Component {
    render() {
        const {
            classes, className, module, onRemove, showInfo, disabled,
        } = this.props;

        if (!module) {
            return null;
        }

        return (
            <div
                className={classnames(classes.root, className)}
            >
                {showInfo && (
                    <IconButton onClick={showInfo} className={classes.infoIcon}>
                        <InfoIcon fontSize="small" />
                    </IconButton>
                )}
                {onRemove && !disabled && (
                    <IconButton onClick={onRemove} className={classes.removeIcon}>
                        <ClearIcon fontSize="small" />
                    </IconButton>
                )}
                <SkillIcon className={classes.moduleIcon} />
                <Typography>
                    {module.name}
                </Typography>
            </div>
        );
    }
}

SelectedSkill.propTypes = {
    classes: PropTypes.object.isRequired,
    module: PropTypes.object.isRequired,
    className: PropTypes.string,
    onRemove: PropTypes.func,
    showInfo: PropTypes.func,
    disabled: PropTypes.bool,
};

SelectedSkill.defaultProps = {
    className: null,
    onRemove: null,
    showInfo: null,
    disabled: false,
};

export default withStyles(styles)(SelectedSkill);
